import React from 'react'

function CTA() {
  const steps = [
    'App herunterladen',
    'Registrieren und Interessen wählen',
    'Benachrichtigungen aktivieren',
    'Kampagnen zu den Slot-Zeiten ansehen',
    'Belohnungen sammeln und auszahlen lassen'
  ]

  return (
    <section id="cta" className="cta section">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">Bereit loszulegen?</h2>
          <p className="cta-subtitle">
            Starte jetzt mit spotx und beginne, Belohnungen zu sammeln. 
            Einfach, schnell und fair.
          </p>
          <div className="cta-steps">
            {steps.map((step, index) => (
              <div key={index} className="cta-step">
                <div className="cta-step-number">{index + 1}</div>
                <div className="cta-step-text">{step}</div>
              </div>
            ))}
          </div>
          <div className="cta-buttons">
            <a href="#" className="btn btn-primary btn-large">
              <span>📱</span>
              App Store
            </a>
            <a href="#" className="btn btn-secondary btn-large">
              <span>🤖</span>
              Google Play
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTA
